import React from 'react';
import { FaBook, FaDownload, FaRegClock, FaUserTie, FaLightbulb } from "react-icons/fa";
import { motion } from 'framer-motion';
import * as FaIcons from "react-icons/fa";


const Instructions = ({ instructions }) => {

  const Icon = ({ iconName, className }) => {
    const IconComponent = FaIcons[iconName];

    if (!IconComponent) return null;

    return <IconComponent className={className} />;
  };


  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mb-8 px-4 sm:px-0"
    >

      {instructions && instructions.map((instruction, index) => (
        <div key={index} className="relative overflow-hidden rounded-2xl shadow-xl border border-blue-100">
        {/* Decorative gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-purple-50 opacity-90"></div>
        
        {/* Floating lightbulb illustration */}
        <motion.div
          animate={{
            rotate: [0, 5, -5, 0],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="absolute -top-6 -right-6 text-yellow-300 opacity-20"
          style={{ fontSize: '8rem' }}
        >
          <FaLightbulb />
        </motion.div>

        <div className="relative z-10 p-6">
          {/* Header with icon */}
          <div className="flex items-center mb-6">
            <div className="bg-white p-3 rounded-xl shadow-sm mr-4">
              <Icon iconName={instruction.icon} className="text-blue-600 text-xl" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-800">{instruction.title}</h3>
              <p className="text-blue-600 text-sm font-medium">{instruction.subtitle}</p>
            </div>
          </div>

          {/* Instructions list with animated items */}
          

          <div className="space-y-4">
            {instruction.items.map((item, idx) => (
              <motion.div 
                key={idx}
                whileHover={{ x: 5 }}
                className="flex items-start bg-white/80 backdrop-blur-sm p-4 rounded-lg shadow-sm border border-gray-100"
              >
                <div className="bg-blue-100 p-2 rounded-lg mr-4">
                  <span className="text-blue-600 font-bold"><Icon iconName={item.icon} /></span>
                </div>
                <p className="text-gray-700 font-medium">
                  {item.description}
                </p>
              </motion.div>
            ))}
          </div>

         
          

        </div>
      </div>

      ))}
    </motion.div>
  );
};

export default Instructions;